module.exports = __webpack_public_path__ + "img/card_and_check.404d99f2.svg";